<template>
  <div class="index">
    <div class="index_bg">
      <div class="index_center">

        <div class="index_s_center">
          <div class=" u-flex u-row-between u-flex-wrap">
            <div class="index_btn" @click="goRZ()">
              <img src="../assets/images/index_btn_1.png" alt="">
            </div>
            <div class="index_btn" @click="goXMCX()">
              <img src="../assets/images/index_btn_2.png" alt="">
            </div>
            <div class="index_btn" @click="goBHCX()">
              <img src="../assets/images/index_btn_3.png" alt="">
            </div>
            <div class="index_btn" @click="goGRZX()">
              <img src="../assets/images/index_btn_4.png" alt="">
            </div>
          </div>
          <div class="index_btn_b">
              <img src="../assets/images/index_btn_5.png" alt="">
          </div>
        </div>
        
      </div>
    </div>
    <div class="footer_bottom"></div>
  </div>
</template>

<script>
import  {sesStorage}  from '@/model/storage.js'
import Qs from "qs";
export default {
  name: "",
  components: {},
  data() {
    return {
     
    };
  },
  methods: {
    goRZ(){
      this.$router.push('./certification')
    },
    goXMCX(){
      this.$router.push('./projectList')
    },
    goBHCX(){
      this.$router.push('./queryList')
    },
    goGRZX(){
      this.$router.push('./personal')
    }
  },
  mounted() {},
  watch: {},
};
</script>

<style lang="scss" scoped>
.index {
  .footer_bottom{
    margin-top: 130px;
  }
  .index_bg{
    width: 100%;
    height: 700px;
    background: url('../assets/images/index_bg.png') center center no-repeat ;
    background-size: cover;
    position: relative;
  }
  .a_link{
    color: #FF9F54;
    cursor: pointer;
  }
  
  .index_center {
    width: 1600px;
    background-color: #fff;
    overflow: hidden;
    position: absolute;
    left: 50%;
    top: 232px;
    margin-left: -800px;
    .index_s_center{
      width: 1494px;
      margin: 48px auto; 
      .index_btn{
        height: 150px;
        margin-bottom: 50px;
        box-shadow: 0 4px 20px rgba(0,0,0,.2);
      }
      .index_btn_b{
        text-align: center;
        padding: 10px 0;
        img{
          display: inline-block;
        }
      }
    }
  }
}

</style>



// WEBPACK FOOTER //
// src/views/Index.vue